/* SquishDrop Halloween buy box (hw-*) — forked from bc-pdp.js.
   Differences from the BC flow:
   - binds [data-hw-buybox] only, so the shared bc-pdp.js (loaded by other bc
     sections on the page) never double-binds this buy box;
   - ATC goes STRAIGHT TO CHECKOUT via a Shopify cart permalink
     (/cart/{variantId}:{qty}). A permalink replaces the cart contents, so a
     halloween order can never mix with Butter Crunch (or any other island's)
     items — that isolation is the point, do not "fix" it back to /cart/add;
   - fires Meta InitiateCheckout when the island pixel is present.
   Countdown + delivery-date behaviors are NOT duplicated here — bc-pdp.js
   already handles those hooks page-wide. */
(function () {
  'use strict';

  document.querySelectorAll('[data-hw-buybox]').forEach(function (box) {
    var tiers = box.querySelectorAll('.bc-tier');
    var atcBtn = box.querySelector('[data-bc-atc]');
    var priceEl = box.querySelector('[data-bc-price]');
    var compareEl = box.querySelector('[data-bc-compare]');
    var stickyPrice = document.querySelector('[data-bc-sticky-price]');
    var ladder = box.querySelectorAll('.bc-giftladder__item');
    var errorEl = box.querySelector('[data-bc-atc-error]');

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || '';
      errorEl.hidden = !msg;
    }

    function select(tier) {
      tiers.forEach(function (t) { t.classList.toggle('is-active', t === tier); });
      var price = parseInt(tier.dataset.price, 10);
      var compare = parseInt(tier.dataset.compare || '0', 10);
      if (priceEl) priceEl.textContent = money(price);
      if (compareEl) compareEl.textContent = compare > price ? money(compare) : '';
      if (stickyPrice) stickyPrice.textContent = money(price);
      var level = parseInt(tier.dataset.giftLevel || '0', 10);
      ladder.forEach(function (item, i) {
        var unlocked = i < level;
        item.classList.toggle('is-unlocked', unlocked);
        var lock = item.querySelector('.bc-lock');
        if (lock) lock.textContent = unlocked ? 'UNLOCKED' : 'Locked';
      });
      showError(tier.hasAttribute('data-unavailable')
        ? 'This pack is sold out right now — pick another size.'
        : '');
    }
    tiers.forEach(function (t) {
      t.addEventListener('click', function () { select(t); });
    });
    if (tiers.length) {
      var def = box.querySelector('.bc-tier[data-default]') || tiers[0];
      select(def);
    }

    /* gallery slider */
    var track = box.querySelector('[data-bc-track]');
    var dots = box.querySelectorAll('[data-bc-dots] span');
    var thumbs = box.querySelectorAll('[data-bc-thumbs] button');
    function setActive(i) {
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
    }
    if (track) {
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var i = parseInt(btn.dataset.index, 10) || 0;
          track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
          setActive(i);
        });
      });
      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          setActive(Math.round(track.scrollLeft / track.clientWidth));
        }, 80);
      }, { passive: true });
    }

    /* buy now: cart permalink -> checkout, cart contents replaced (island isolation) */
    if (atcBtn) {
      atcBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var active = box.querySelector('.bc-tier.is-active');
        if (!active) { showError('Choose a pack size first.'); return; }

        var variantId = parseInt(active.dataset.variantId || '', 10);
        if (!variantId) {
          showError('This option is not available to buy yet. Please pick another pack.');
          return;
        }
        var qty = parseInt(active.dataset.qty || '1', 10) || 1;

        showError('');
        atcBtn.disabled = true;
        atcBtn.textContent = 'Taking you to checkout…';

        if (window.fbq) {
          var priceCents = parseInt(active.dataset.price || '0', 10);
          fbq('track', 'InitiateCheckout', {
            content_ids: [String(variantId)],
            content_type: 'product_variant',
            value: priceCents / 100,
            currency: 'USD',
            num_items: qty
          });
        }

        window.location.href = '/cart/' + variantId + ':' + qty;
      });
    }
  });
})();
